import CryptoJS from 'crypto-js';
import { JSEncrypt } from 'jsencrypt';
import { v4 as uuidv4 } from 'uuid';

/**
 * 对称加密
 */
export function encryptAes(content, key) {
    const keyTmp = CryptoJS.enc.Utf8.parse(key);
    const contentTmp = CryptoJS.enc.Utf8.parse(content);
    const encryptResult = CryptoJS.AES.encrypt(contentTmp, keyTmp, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    });
    const ret = encryptResult.ciphertext.toString().toUpperCase(); // hex
    // const ret = encryptResult.toString().toUpperCase(); //base64
    return ret;
}

/**
 * 非对称加密
 */
export function loginRsaEncrypt(pwd) {
    // 公钥
    // eslint-disable-next-line operator-linebreak
    let PUBLIC_KEY =
        'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCrLCvPQVj1dYDdtb34bUGrxAYHLDMQdsjbk7+pY/ugKdHKhxQo1E43gt4HMgjFuirvaGfh1NJ2FCX9thillLZlHhkNOUcEQSbpcJycQ9wq7FBtOk7lE0dBBA9t3Zk/qBx2A2xPVvVNf9lNdNDDp2vXhQ549H9hg1s1TPHFEags3QIDAQAB';
    PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----${PUBLIC_KEY}-----END PUBLIC KEY-----`;

    // 使用公钥加密
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(PUBLIC_KEY);
    const encrypted = encrypt.encrypt(pwd);
    return encrypted;
}

/** 生成 uuid */
export function getUidV4() {
    return uuidv4();
}
